import BaseSchema from "./base";

class Phase extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "phases";
  static fields = [
    "uuid",
    "installation",
    "createdAt",
    "updatedAt",
    "name",
    "order",
    "isNotPerformed",
  ];

  static relatedFields = {
    samples: {
      many: true,
      reversedKey: "phase",
      tableName: "samples",
      cascade: true,
    },
    installationObject: {
      field: "installation",
      tableName: "installations",
    },
  };

  static dateFields = ["createdAt", "updatedAt"];

  get configurationLinesCount() {
    if (this.samples == undefined) throw new Error("Samples not loaded");
    const lineCount = {};
    for (const sample of this.samples) {
      for (const parameterUuid of sample.mainParameters) {
        lineCount[parameterUuid] = 1;
      }
    }
    return lineCount;
  }
}

export default Phase;
